export default (props: any, $store: any, _state: any, _sort: any, _filter: any, getQuestions: () => void) => {
    return [
        {
            event: "GroupQuestions\\GroupQuestionsCreated",
            callback: async (e: {group: string; questions: string[]}) => {
                if (e.group !== props.group.id) {
                    return;
                }
                getQuestions();
            },
        },
        {
            event: "GroupQuestions\\GroupQuestionParamsUpdated",
            callback: async (e: {group: string; question: {id: string; is_pinned: boolean; params: any}}) => {
                if (e.group !== props.group.id) {
                    return;
                }

                const questionIndex = $store.group.questions.findIndex((q: any) => q.id === e.question.id);
                if (questionIndex !== -1) {
                    $store.group.questions[questionIndex].is_pinned = e.question.is_pinned;
                    $store.group.questions[questionIndex].params = e.question.params;
                }

                getQuestions();
            },
        },
    ];
};
